/**
 * Reads the handoff intent the public site puts on the `/login` URL.
 *
 * The public site (apps/www) carries no authentication of its own: its Sign In
 * and Sign Up controls are links to this origin, which is the only one Entra
 * will redirect back to. The intent rides along so a visitor who clicked
 * "Sign Up" over there does not have to click it again here.
 */

/** Marks which side of the split a sign-in handoff came from. */
export type AuthIntent = "signIn" | "signUp";

const INTENT_PARAM = "intent";

const INTENT_VALUES: Record<AuthIntent, string> = {
  signIn: "signin",
  signUp: "signup",
};

export function readAuthIntent(search: URLSearchParams): AuthIntent | null {
  const value = search.get(INTENT_PARAM);
  if (value === INTENT_VALUES.signUp) return "signUp";
  if (value === INTENT_VALUES.signIn) return "signIn";
  return null;
}
